module.exports = __webpack_public_path__ + "static/image/logo-family/logo_one.png?daab2f24";